import React from 'react';
import type { BlockBadgesList } from 'types/block-badges-list';

import Image from 'next/image';
import { Wrap } from '@leafwell/components';

import HeadingBody from './heading-body';

const BadgesList: React.FC<BlockBadgesList> = ({
  sectionId,
  title,
  badges,
}) => {
  return (
    <Wrap id={sectionId} className="justify-items-center">
      <HeadingBody
        className="text-center max-w-xl"
        level="2"
        title={title}
        tagName="h2"
      />
      {badges?.length > 0 ? (
        <ul className="relative flex flex-wrap justify-start md:justify-center items-center	max-w-5xl gap-4 md:gap-6">
          {badges.map(({ badge }, idx) => {
            return (
              <li
                key={`income-${idx}`}
                className="inline-flex items-center gap-2 font-medium rounded-3xl select-none py-1 px-4 border-2 border-lilac-300 bg-lilac-50 text-black w-fit"
              >
                <Image
                  src="/check-circle.svg"
                  alt=""
                  className=""
                  loading="lazy"
                  width={17}
                  height={17}
                />
                {badge}
              </li>
            );
          })}
        </ul>
      ) : null}
    </Wrap>
  );
};

export default BadgesList;
